import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import notificationsService from "../../../services/notifications.service";

const initialState = {
  notifications: [],
  role: null,
  status: "idle",
  error: null,
};

export const fetchNotifications = createAsyncThunk(
  "notifications/fetchNotifications",
  async () => {
    const response = await notificationsService.getAllActives();
    return response.notifications;
  }
);

const notificationsSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    setRole: (state, action) => {
      state.role = action.payload;
    },
    clearNotifications: (state) => {
      state.notifications = [];
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchNotifications.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchNotifications.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.notifications = action.payload;
      })
      .addCase(fetchNotifications.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export const selectNotifications = (state) => state.notifications.notifications;
export const selectNotificationsStatus = (state) => state.notifications.status;
export const { clearNotifications } = notificationsSlice.actions;
export default notificationsSlice.reducer;
